export default __webpack_public_path__ + "static/media/emptyTask.9dbad012.png";